/**
 * @description Ações relacionadas aos alertas do sistema
 * @author Bene Lemuel Dantas Gondim
 * @file alertaActions.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

export const ALERTA_USUARIO_SEM_PERMISSAO_ERROR = 'ALERTA_USUARIO_SEM_PERMISSAO_ERROR'
export const ALERTA_CAMINHO_NAO_ENCONTRADO = 'ALERTA_CAMINHO_NAO_ENCONTRADO'
export const ALERTA_SALVO_SUCESSO = 'ALERTA_SALVO_SUCESSO'
export const ALERTA_ERRO_NO_FORMULARIO_ERROR = 'ALERTA_ERRO_NO_FORMULARIO_ERROR'
export const ALERTA_STATUS_DESCONHECIDO = 'ALERTA_STATUS_DESCONHECIDO'
export const ALERTA_ERRO_DE_APLICACAO = 'ALERTA_ERRO_DE_APLICACAO'
export const ALERTA_CREDENCIAIS_INVALIDAS = 'ALERTA_CREDENCIAIS_INVALIDAS'

export const criarAlerta = (payload, router, caminhoRetorno) => {
  if (!payload || !payload.status) {
    return async (dispatch) => {
      dispatch({
        type: ALERTA_ERRO_DE_APLICACAO,
        status: true,
        innerErrorMessage: 'Erro de aplicação não tratado',
        variant: 'error',
        message: 'Erro na aplicação WEB. Por favor, entre em contato com o NTI/PCIRN',
      })
      if (router && caminhoRetorno) {
        router.history.push(caminhoRetorno)
      }
    }
  }

  switch (payload.status) {
    case 403: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_USUARIO_SEM_PERMISSAO_ERROR,
            status: payload.status,
            innerErrorMessage: payload.data.error.innerError.message,
            variant: 'warning',
            message: payload.data.error.innerError.message || 'O usuário não tem permissão para executar essa ação',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }

    case 404: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_CAMINHO_NAO_ENCONTRADO,
            status: payload.status,
            innerErrorMessage: `Endereço não encontrado: URL: ${payload.request.responseURL}`,
            variant: 'error',
            message: payload.data.error?.innerError?.message || 'Caminho da requisição não encontrado',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }

    case 422: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_USUARIO_SEM_PERMISSAO_ERROR,
            status: payload.status,
            innerErrorMessage: payload.data.error.innerError.message,
            variant: 'error',
            message: 'Erro ao processar requisição. Entre em contato com o NTI/PCIRN',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }

    case 400: {
      if (payload.data.error.innerError.message.search('E11000') !== -1) {
        return async (dispatch) => {
          dispatch(
            {
              type: ALERTA_ERRO_NO_FORMULARIO_ERROR,
              status: payload.status,
              innerErrorMessage: payload.data.error.innerError.message,
              variant: 'error',
              message: 'Erro no formulário. Já existe um cadastro com esse nome',
            },
            router && caminhoRetorno && router.history.push(caminhoRetorno)
          )
        }
      }
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_ERRO_NO_FORMULARIO_ERROR,
            status: payload.status,
            innerErrorMessage: payload.data.error.innerError.message,
            variant: 'error',
            message: 'Erro no formulário. Tente novamente',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }

    case 401: {
      return async (dispatch) => {
        if (payload.case === 'login') {
          dispatch(
            {
              type: ALERTA_CREDENCIAIS_INVALIDAS,
              status: payload.status,
              innerErrorMessage: payload.data.error.innerError.message,
              variant: 'error',
              message: 'Credenciais inválidas',
            },
            router && caminhoRetorno && router.history.push(caminhoRetorno)
          )
        }
      }
    }

    case 501: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_ERRO_NO_FORMULARIO_ERROR,
            status: payload.status,
            innerErrorMessage: 'Funcionalidade incompatível para a versão do objeto',
            variant: 'error',
            message: 'Funcionalidade incompatível para a versão do objeto',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }

    case 200:
    case 201: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_SALVO_SUCESSO,
            status: payload.status,
            innerErrorMessage: '',
            variant: 'success',
            message: payload.data.message || 'Ação realizada com sucesso',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }

    case 204: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_SALVO_SUCESSO,
            status: payload.status,
            innerErrorMessage: '',
            variant: 'success',
            message: 'Deletado com sucesso',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno.pathname)
        )
      }
    }

    default: {
      return async (dispatch) => {
        dispatch(
          {
            type: ALERTA_STATUS_DESCONHECIDO,
            status: payload.status || 500,
            innerErrorMessage: 'Erro de servidor desconhecido',
            variant: 'error',
            message: 'Erro de servidor - Entre em contato com o NTI/PCIRN',
          },
          router && caminhoRetorno && router.history.push(caminhoRetorno)
        )
      }
    }
  }
}
